import { render, staticRenderFns } from "./InputPrompt.vue?vue&type=template&id=521fd89e&"
import script from "./InputPrompt.vue?vue&type=script&lang=js&"
export * from "./InputPrompt.vue?vue&type=script&lang=js&"
import style0 from "./InputPrompt.vue?vue&type=style&index=0&id=521fd89e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports